import styled from "styled-components";

interface CurrentStatusStyleProps {
  powerOn?: boolean;
  statNormal?: string;
}

export const EquipCurrentStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const EquipCurrentTime = styled.div`
  display: flex;
  padding-right: 4px;
  color: ${(props) => props.theme.colors.black60};
  font-size: 1.2rem;
  font-size: 500;
  gap: 4px;

  span {
    padding-right: 4px;
    border-right: 1px solid ${(props) => props.theme.colors.black10};
  }
`;

export const EquipCurrentPower = styled.div<CurrentStatusStyleProps>`
  display: flex;
  height: 24px;
  padding: 0 12px;
  color: ${(props) => props.theme.colors.white100};
  font-size: 1.2rem;
  font-weight: 600;
  background: ${(props) =>
    props.powerOn ? props.theme.colors.primary100 : props.theme.colors.black60};
  border-radius: 13px;
  align-items: center;
  justify-content: center;
`;

export const EquipCurrentStat = styled.div<CurrentStatusStyleProps>`
  display: flex;
  height: 24px;
  padding: 0 12px;
  color: ${(props) => props.theme.colors.white100};
  font-size: 1.2rem;
  font-weight: 600;
  background: ${(props) =>
    props.statNormal === "normal"
      ? props.theme.colors.greenStatus
      : props.statNormal === "warning"
      ? props.theme.colors.yellowStatus
      : props.statNormal === "critical"
      ? props.theme.colors.redStatus
      : props.theme.colors.gray100};
  border-radius: 13px;
  align-items: center;
  justify-content: center;
`;
